<template>
  <a-modal
    ref="createModal"
    title="预测对比"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="commitdata"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
      class="full-width"
    >
      <a-form-model-item label="预测对比月份" prop="monthList">
        <global-select
          :maxTagCount="20"
          :maxTagTextLength="7"
          :value.sync="commitdata.monthList"
          selectType="selectMultiple"
          requestApi="/scp/salesForecastDetail/monthPullDown"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="期间" prop="forecastMonthTem">
        <global-select
          :focusGet="true"
          @change="handleMonthChange"
          :setParams="{monthList:commitdata.monthList.join(',')}"
          :value.sync="commitdata.forecastMonthTem"
          selectType="select"
          requestApi="/scp/salesForecast/monthPeriodPullDown"
          :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
        />
      </a-form-model-item>
      <a-form-model-item label="预测名称" prop="forecastName">
        <a-input disabled="true" v-model="commitdata.forecastName" />
      </a-form-model-item> -->
      <a-form-model-item label="版本" prop="versionCodeList">
        <global-select
          :maxTagCount="20"
          :maxTagTextLength="7"
          :dropdown-match-select-width="false"
          @change="handleVersionChange"
          :value.sync="commitdata.versionCodeList"
          selectType="selectMultiple"
          :setParams="{monthList:commitdata.monthList.join(',')}"
          requestApi="/scp/salesForecast/versionCodePullDown"
          :selectItem="{ value: 'realValue', label: 'bringOutDataTwo'}"
        />
      </a-form-model-item >
      <!-- <a-form-model-item label="说明">
        <a-input disabled="true" v-model="commitdata.versionDescription" />
      </a-form-model-item > -->
    </a-form-model>
  </a-modal>
</template>

    <script>
  // 表单字段
  export default {
    props: {
      uomClassOptions: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {
        spuItemCodeSetParams: {
          forecastName: ''
        },
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        // 表单校验
        rules: {
            monthList: [{ required: true, message: '选择对比月份不能为空', trigger: 'change' }],
            versionCodeList: [{ required: true, message: '版本号不能为空', trigger: 'change' }]
        },
        commitdata: {
            monthList: [], // 月份
            versionCodeList: [], // 版本
            forecastName: '', // 预测名称
            versionCode: '', // 版本
            versionDescription: '' // 版本描述
        },
        inputType: 1,
        mode: ['month', 'month'],
        // 状态数据字典
        // 当前控件配置:
        confirmLoading: false,
        visible: false,
        typeList: [],
        unitOfMeasureList: []
      }
    },
    created () {},
    methods: {
      handleMonthChange (val, selectList) {
      if (val) {
        const filteredItem = selectList.filter(item => item.selectedValue === val);
        this.commitdata.forecastName = filteredItem[0].bringOutDataOne
        this.commitdata.forecastMonthStart = filteredItem[0].label
        this.commitdata.forecastMonthEnd = filteredItem[0].realValue
      } else {
        this.commitdata.forecastName = undefined;
      }
    },
    handleForecastName (val, selectList) {
      this.commitdata.versionCode = ''
      this.commitdata.versionDescription = ''
    },
      handleVersionChange (val, selectList) {
        const filteredItem = selectList.filter((item) => item.realValue === val)
        this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
      },
      show () {
        // this.addLine()
        this.visible = true
      },
      // 关闭模态框
      close () {
        this.reset()
        this.visible = false
      },
      confirmValidate () {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.confirm()
          }
        })
      },
      confirm () {
      //   this.download('/scp/salesForecast/exportForecastContrast', {
      //   ...this.commitdata
      // }, `销售预测对比_${new Date().getTime()}.xlsx`)
              this.confirmLoading = false
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              this.$emit('handle-export-confirm', { ...this.commitdata })
              // 刷新表单
              this.reset()
      },
      // 表单重置
      reset () {
        this.commitdata = {
          forecastName: '', // 预测名称
          forecastMonthStart: '', // 预测起始月
          forecastMonthEnd: '', // 预测起始月
          forecastMonthTem: [], // 临时时间
          dtoList: [], // 列表数据
          monthList: []
        }
        this.typeList = []
      }
    }
  }
  </script>

    <style scoped lang="less">
  /deep/.ant-select {
    width: 250px;
  }
  /deep/.ant-input {
    width: 250px;
  }
  /deep/.ant-modal-body {
    height: 400px;
    overflow-y: scroll;
  }
  .rp-width {
    width: 200px;
  }
  .ip-width {
    width: 150px;
  }
  .full-width {
    width: 100%;
  }
  .col-tips {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4470588235294118);
    line-height: 22px;
  }
  </style>
